<template>
    <div id="folletos-list">         
        <div class="row p-2">
            <div class="col-sm-12 text-center">
                <h4>Consulta o descarga nuestros folletos</h4>
                <p class="mb-5">Descarga aquí nuestros folletos para entregar a tus clientes o colocar en el escaparate de tu agencia</p>
                <div class="brochures-grid">                    
                    <div class="brochure" v-for="item in listaFolletos" :key="item.id">            
                        <p class="brochure-desc">{{ item.des1 }} <br> <small>{{ item.des2 }}</small></p>
                        <a :href="imagen(item.id,1)" target="_blank">
                            <!-- <img src="img/pdf-1.jpg" alt="" class="brochure-img img-fluid" > -->
                            <img class="brochure-img img-fluid"
                                :src="imagen(item.id,0)"/>
                        </a>
                        <a :href="imagen(item.id,1)" target="_blank">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download mr-2" viewBox="0 0 16 16">
                            <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
                            <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
                            </svg>Descargar</a>
                    </div>                                                
                </div>

            </div>
        </div>        
        
    </div>                             
</template>

<script>

import { mapState, mapMutations, mapActions } from 'vuex'; //store

export default {
    name: 'folletos',
    components: {
        //hotel,
        
    },
    data() {
        return {
            listaFolletos: [], 
            
        }
    },
    computed: {
        ...mapState(['auth','datos','errores','G']),

       
        listaNum() {
            return Object.keys(this.listaFolletos).length;        
        },        

    },
    methods: {
        ...mapMutations(['loading','alerta','modal']),
        ...mapActions(['exec']),

        async leemos() {        
            //this.loading();    
            var args={ sid: this.auth.token };
            let r=await this.$store.dispatch('exec',{api:'hoteles_folletos', arg:args});
            this.leemos_back(r);        
        },

        leemos_back(r) {
            if (r.error) {              
                this.modal({tit:"Folletos", msg: r.datos});            
            }
            this.listaFolletos=r.datos[0];            
            
            //console.log("*Folletos",this.listaFolletos);
        },

        

        imagen(id,tp=0) {
            let url=this.G.url_img + '?w=' + new Date().valueOf() + '|vc_agencias|ev_documentos|' + id + '|||' 
                + (tp==1 ? '' : 'thumb' ); 
            //console.log("*imagen",url);
            return url;            
        },
        
    },
    mounted() {
        this.leemos();
        
    },
}
</script>
